import {CompanyMatches, CompanyMatchesJSON} from '../types/InboxTypes';

import {mapApplicantKeyFacts} from './mapApplicantKeyFacts';

export default class InboxSerializer {
  static toObjectPaginated(payload: CompanyMatchesJSON): CompanyMatches {
    return {
      totalCountPerStatus: payload.total_count_per_status,
      data: payload.data.map((match) => {
        return {
          resourceId: match.resource_id,
          updatedAt: match.updated_at,
          createdAt: match.created_at,
          desiredSalary: match.desired_salary,
          bestAddress: match.best_address,
          campaignName: match.campaign_name,
          status: match.status,
          tags: match.tags.map((tag) => {
            return {
              resourceId: tag.resource_id,
              tagLabel: tag.tag_label,
            };
          }),
          applicant: {
            resourceId: match.applicant.resource_id,
            personalInformation: {
              resourceId: match.applicant.personal_information.resource_id,
              firstName: match.applicant.personal_information.first_name,
              lastName: match.applicant.personal_information.last_name,
              email: match.applicant.personal_information.email,
              mobilePhoneNumber: match.applicant.personal_information.mobile_phone_number,
              linkedinUrl: match.applicant.personal_information.linkedin_url,
            },
            keyFacts: mapApplicantKeyFacts(match.applicant.key_facts),
            resumeUrl:
              match.applicant.resume_url?.trim() ||
              match.applicant.personal_information.resume_url?.trim() ||
              undefined,
          },
          companyJobPosting: {
            resourceId: match?.company_job_posting?.resource_id || '',
            title: match?.company_job_posting?.title || '',
            salary: {
              min: match?.company_job_posting?.salary.min,
              max: match?.company_job_posting?.salary.max,
            },
            locations:
              match?.company_job_posting?.locations.map((location) => {
                return {
                  id: location.id,
                  countryISOCode: location.country_iso_code,
                  city: location.city,
                  zipCode: location.zip_code,
                  street: location.street,
                  houseNumber: location.house_number,
                };
              }) || [],
            departments: (match?.company_job_posting?.departments || []).map((dep) => ({
              resourceId: dep.resource_id,
              name: {
                en: dep.name.en,
                de: dep.name.de,
              },
              subdepartments: dep.subdepartments?.map((sub) => ({
                resourceId: sub.resource_id,
                name: {
                  en: sub.name.en,
                  de: sub.name.de,
                },
              })),
            })),
            remoteHiring: {
              allowed: match?.company_job_posting?.remote_hiring.allowed || false,
              region: match?.company_job_posting?.remote_hiring.region || '',
            },
          },
        };
      }),
      pagination: {
        page: payload.pagination.page,
        perPage: payload.pagination.per_page,
        totalPages: payload.pagination.total_pages,
        totalCount: payload.pagination.total_count,
        nextPage: payload.pagination.next_page,
        previousPage: payload.pagination.previous_page,
      },
    };
  }
}
